import { Character as SharedCharacter } from '../../components/atomic/character/character/Character';
import characterImg from './character.png';
import './Character.css';

/** From welcome_screen_2.svg → character_image (≈361 992 597×533). */
export function Character() {
  return (
    <SharedCharacter
      className="welcome-delivery-2-character"
      src={characterImg}
    />
  );
}
